// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"MenuButton-menuButton-3nh0N","isDisabled":"MenuButton-isDisabled-2bZfj"};